import { Document } from './document';
import { NotificationMap } from './notificatonmap';
import { SkillDocWrapper } from '../skills/skilldocwrapper';
import { UserAttrSkillWrapper } from '../skills/userattrskillwrapper';
import { CustomFields } from './customfields';
import { Location } from './Location';
import { Language } from './language';
import _ from 'lodash';
export class UserProfile {
  public firstName: string = '';
  public lastName: string = '';
  public middleName: string = '';
  public preferredName: string = '';
  public userId: number = 0;
  public email: string = '';
  public phoneNum: string = '';
  public address1: string = '';
  public address2: string = '';
  public city: string = '';
  public state: string = '';
  public zip: number | string = 0;
  public timezone: string = '';
  public dob: any = '';
  public country: string = '';
  public employeeType: any;
  public availabilityStatus: string = '';
  public notificationTypeMap: NotificationMap = new NotificationMap();
  public skillTypes: SkillDocWrapper[] = [];
  public resumes: Document[] = [];
  public attachements: Document[] = [];
  public forcePwdChg: boolean = false;
  public blocked : boolean = false;
  public profilePicGUID: string = '';
  public profilePicExtType: string = '';
  public userProfileBasePath: string = '';
  public profilePictureFile: any;
  public userProfileStrength: number = 0;
  public userAttributeSkills: UserAttrSkillWrapper[] = [];
  public newPassword: string = '';
  public oldPassword: string = '';
  public currentPassword: string = '';
  public desiredMinSalary: string = '';
  public desiredMaxSalary: string = '';
  public desiredSalary: string = '';
  public desiredLocations: Location[] = [];
  public jobAvailability: string = '';
  public jobAvailabilityOptions: Array<any> = [];
  public remoteWork: boolean = false;
  public periodForSalary: string = '';
  public jobSearchStatus: string = '';
  public currency: string = '';
  public desiredLocationString: string = '';
  public sourceType: string = '';
  public enableForum: boolean = false;
  public isJobAlertEnabled: boolean = false;
  public languages: string[] = [];
  public language: Language = new Language();
  public totalFlightHours: string = '';
  public customFields: CustomFields = new CustomFields();
  public additionalSupportRequired:string = '0';
  public role: string = '';
  public userAgreement: number | undefined;
  public userAccountRegistrationStatus: string = '';

  public getFullName(): string {
    return this.firstName + ' ' + this.lastName;
  }

  public getFullAddress() {
    let UserAddress =
    (this.address1 && this.address1.length > 0) ?  this.address1.toString().trim() : '' +
    (!(this.address1 && this.address1.length > 0 && this.address1.toString().trim() ) ? '' : ', ') +
      (this.address2 === undefined ? '' : this.address2) +
      (!this.address2 ? '' : ', ') +
      this.city +
      (!this.city ? '' : ', ') +
      this.state +
      (!this.state ? '' : ', ') +
      this.zip +
      (!this.country ? '' : ', ') +
      _.capitalize(this.country);
    UserAddress = UserAddress.replace(/null,/g, '').replace(/null/g, '');
    if (typeof UserAddress !== 'undefined') {
      return UserAddress;
    }
    return '';
  }
}
